import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';

@NgModule({
  declarations: [SideMenuComponent, LayoutComponent, HeaderComponent],
  imports: [
    CommonModule,
    AvatarModule,
    BreadcrumbModule,
    ButtonModule,
    DividerModule,
    OverlayPanelModule,
    PanelMenuModule,
    ScrollTopModule,
    SidebarModule,
    ToastModule,
  ],
  exports: [SideMenuComponent, LayoutComponent, HeaderComponent],
})
export class LayoutModule {}
